import { goRequest } from '../utils/httpClientTs';
import type { PortalAccountContact } from '../types/portalAccount';

export const getPortalAccount = async (): Promise<PortalAccountContact> => {
  return goRequest<PortalAccountContact>({
    url: '/portal/account/me',
    method: 'GET',
  });
};

export const updatePortalAccount = async (
  data: PortalAccountContact
): Promise<PortalAccountContact> => {
  return goRequest<PortalAccountContact>({
    url: '/portal/account/me',
    method: 'PATCH',
    data,
  });
};
